import {IDataService} from "@/shared/DataService/IDataService";
import {IPlexSummary} from "@/shared/DataService/IPlexSummary";
import AppSettings from "@/shared/Configuration/appSettings";
import {Plex} from "@/shared/DataService/plex";
import * as _ from "lodash";
import {INodeModel} from "@/shared/models/abstract/INodeModel";
import {IEdgeModel} from "@/shared/models/abstract/IEdgeModel";
import {IEntitySummary} from "@/shared/DataService/IEntitySummary";
import {EntityType} from "@/shared/models/entityType";

export default class NeoDataService implements IDataService {
    appSettingsExist(): Promise<boolean> {
        return undefined;
    }

    getAllPlexes(): Promise<IPlexSummary[]> {
        return undefined;
    }

    getAppSettings(): Promise<AppSettings> {
        return undefined;
    }

    getPlex(id: string): Promise<Plex> {
        return undefined;
    }

    plexCount(): Promise<number> {
        return undefined;
    }

    plexIdExists(id: string): Promise<boolean> {
        return undefined;
    }

    removePlex(id: string): Promise<boolean> {
        return undefined;
    }

    upsertAppSettings(settings: AppSettings): Promise<boolean> {
        return undefined;
    }

    upsertPlex(project: Plex): Promise<boolean> {
        return undefined;
    }


    getEdgeById(id: string): Promise<IEdgeModel> {
        return undefined;
    }

    getFavorites(count: number): INodeModel[] {
        return [];
    }

    getNodeById(id: string): Promise<INodeModel> {
        return undefined;
    }

    removeEdge(model: IEdgeModel): Promise<boolean> {
        return undefined;
    }

    removeEdgeById(id: string): Promise<boolean> {
        return undefined;
    }

    removeNode(model: INodeModel): Promise<boolean> {
        return undefined;
    }

    removeNodeById(id: string): Promise<boolean> {
        return undefined;
    }

    upsertEdge(model: IEdgeModel): Promise<boolean> {
        return undefined;
    }

    upsertNode(model: INodeModel): Promise<boolean> {
        return undefined;
    }

    searchName(stuff: string, includeGroups: boolean): Promise<IEntitySummary[]> {
        return undefined;
    }

    nameExists(name: string): Promise<IEntitySummary> {
        return undefined;
    }

    removeGroup(model: INodeModel): Promise<boolean> {
        return undefined;
    }

    getGroupHierarchy(id: string): Promise<INodeModel[]> {
        return undefined;
    }

    searchGroups(stuff: string): Promise<IEntitySummary[]> {
        return undefined;
    }

    getGroupChildren(id: string): Promise<IEntitySummary[]> {
        return undefined;
    }

    getChildren(id: string): Promise<INodeModel[]> {
        return undefined;
    }

    getParents(id: string): Promise<INodeModel[]> {
        return undefined;
    }

    setParentGroup(nodeId: string, groupId: string): Promise<boolean> {
        return undefined;
    }

    connect(sourceId: string, targetId: string, name: string): Promise<string> {
        return undefined;
    }

    areConnected(sourceId: string, targetId: string, anyDirection: boolean): Promise<boolean> {
        return undefined;
    }

    edgeExists(id: string): Promise<boolean> {
        return undefined;
    }

    getEdgesBetween(sourceId: string, targetId: string, anyDirection: boolean): Promise<IEdgeModel[]> {
        return undefined;
    }

    groupExists(id: string): Promise<boolean> {
        return undefined;
    }

    nodeExists(id: string): Promise<boolean> {
        return undefined;
    }

    async getItemsOfType(entityType: EntityType, count: number = 10) {
        return [];
    }
}
